/**
 * OrbDocTutorialsIntermediateCrossOrbitalENDocScreenView
 *
 * Functional component — logic + state-based JSX rendering.
 *
 * @generated from schema
 * @trait OrbDocTutorialsIntermediateCrossOrbitalENDocScreen
 */

import { useOrbDocTutorialsIntermediateCrossOrbitalENDocScreenLogic } from '@/hooks/traits/useOrbDocTutorialsIntermediateCrossOrbitalENDocScreenLogic';
import type { OrbDocTutorialsIntermediateCrossOrbitalENDocScreenConfig } from '@/hooks/traits/useOrbDocTutorialsIntermediateCrossOrbitalENDocScreenLogic';
import type { EntityRow, EntityWith, EventPayload, EventPayloadValue, FieldValue } from '@almadar/core';
function getNestedValue(obj: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined, path: string): FieldValue | undefined {
  if (obj === null || obj === undefined || !path) return undefined;
  if (typeof obj !== 'object') return undefined;
  if (!path.includes('.') && !Array.isArray(obj)) {
    return (obj as Record<string, FieldValue | undefined>)[path];
  }
  let value: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined = obj;
  for (const part of path.split('.')) {
    if (value === null || value === undefined || typeof value !== 'object') return undefined;
    if (Array.isArray(value)) {
      if (!/^\d+$/.test(part)) return undefined;
      value = (value as readonly (EventPayloadValue | FieldValue | null | undefined)[])[Number(part)];
      continue;
    }
    value = (value as Record<string, FieldValue | undefined>)[part];
  }
  return value as FieldValue | undefined;
}
import type { OrbDocTutorialsIntermediateCrossOrbitalENDocView as OrbDocTutorialsIntermediateCrossOrbitalENDocViewEntity } from '@app/shared';
import { OrbDocTutorialsIntermediateCrossOrbitalENDocBodyView } from '@/components/traits/OrbDocTutorialsIntermediateCrossOrbitalENDocBodyView';
import { OrbDocTutorialsIntermediateCrossOrbitalENDocFooterView } from '@/components/traits/OrbDocTutorialsIntermediateCrossOrbitalENDocFooterView';
import { OrbDocTutorialsIntermediateCrossOrbitalENDocHeaderView } from '@/components/traits/OrbDocTutorialsIntermediateCrossOrbitalENDocHeaderView';
import { Stack } from '@almadar/ui/components';
import { UISlotComponent } from '@almadar/ui/components';
import { TraitScopeProvider } from '@almadar/ui/providers';

interface OrbDocTutorialsIntermediateCrossOrbitalENDocScreenViewProps {
  config?: Partial<OrbDocTutorialsIntermediateCrossOrbitalENDocScreenConfig>;
}

export function OrbDocTutorialsIntermediateCrossOrbitalENDocScreenView({ config: propsConfig }: OrbDocTutorialsIntermediateCrossOrbitalENDocScreenViewProps) {
  const { state, data, lastPayload, lastEvent, slotWriter, loading, pendingEvent, pendingFrom, error, fields, dispatch, actions, config } = useOrbDocTutorialsIntermediateCrossOrbitalENDocScreenLogic(propsConfig);

  // Entity collection from server response data
  const entity: EntityRow[] = data['OrbDocTutorialsIntermediateCrossOrbitalENDocView'] ?? [];
  // Payload from last event (for @payload bindings in render-ui)
  const payload = lastPayload;

  return (
    <TraitScopeProvider orbital="OrbDocTutorialsIntermediateCrossOrbitalEN" trait="OrbDocTutorialsIntermediateCrossOrbitalENDocScreen">
      <UISlotComponent slot="main" pattern={slotWriter['main'] === 'INIT' ? "stack" : "clear"} sourceTrait="OrbDocTutorialsIntermediateCrossOrbitalENDocScreen">{slotWriter['main'] === 'INIT' ? (<Stack direction="vertical" gap="none"><OrbDocTutorialsIntermediateCrossOrbitalENDocHeaderView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /><OrbDocTutorialsIntermediateCrossOrbitalENDocBodyView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /><OrbDocTutorialsIntermediateCrossOrbitalENDocFooterView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /></Stack>) : null}</UISlotComponent>
    </TraitScopeProvider>
  );
}

export default OrbDocTutorialsIntermediateCrossOrbitalENDocScreenView;
